import {componentContextTypes, IComponentContext} from '@mintdata/mint-kit/api/components/ComponentContext';
import * as React from 'react';

export abstract class BaseComponentWithContext<PropsType, StateType = any> extends React.Component<PropsType, StateType>
{
    public static contextTypes = componentContextTypes;

    public context:IComponentContext;
}
